<template>
	<div id='altaPago' >
		<h2>Pago</h2>
		<p>
			<hijo1 v-if='buscar' v-on:eventoC= 'recibeC(...arguments)'>Cargando contratos...</hijo1>
  		</p>

		<form v-on:submit.prevent= 'guardarMovimiento' id="visible">
			
			<table align="center" border="1" class="table is-striped">
          	  <tbody>
				<tr>
				  <td>Contrato Num. </td>
				  <td>
				  	<input type="text" name='contrato' required="true" disabled v-model='movimientos.contrato' class="input is-rounded" >
		    		<button type='button' v-on:click='aBuscar' class="button is-primary is-rounded">BUSCAR</button>

				  </td>
				</tr>
				<tr>
				  <td>Inquilino</td>
				  <td><label name='inquilinoNombre' v-model='movimientos.inquilinoNombre' >{{movimientos.inquilinoNombre}}</label></td>
				</tr>
				<tr>
				  <td>Propiedad</td>
				  <td><label name='propiedadNombre' v-model='movimientos.propiedadNombre' >{{movimientos.propiedadNombre}}</label></td>
				</tr>

				<tr>
				  <td>Giro</td>
				  <td><label name='giro' v-model='movimientos.giro' ><b>{{movimientos.giro}}</b></label></td>
				</tr>
				<tr>
				  <td>Familia</td>
				  <td><label name='familia' v-model='movimientos.familia' ><b>{{movimientos.familia}}</b></label></td>
				</tr>	
				<tr>
				  <td>Sub familia</td>
				  <td><label name='subfam' v-model='movimientos.subfamilia' >{{movimientos.subfamilia}}</label></td>
				</tr>	
				<tr>
				  <td>Dueno</td>
				  <td><label name='dueno' v-model='movimientos.dueno' >{{movimientos.dueno}}</label></td>
				</tr>
				<tr>
				  <td>Renta mensual</td>
				  <td><label name='renta' v-model='renta' >$ {{formateaNumero(renta)}}</label></td>
				</tr>
				<tr>
					<td></td>
				</tr>
				<tr>
				  <td>Concepto</td>
				  <td>
					<div class="select is-rounded">
						<select name='concepto' v-model='movimientos.concepto' required  >
						  <option value="A CUENTA RENTA" selected >A CUENTA RENTA</option>
						  <option value="A CUENTA AGUA">AGUA</option>
						  <option value="A CUENTA LUZ">LUZ</option>
						  <option value="MANTENIMIENTO">MANTENIMIENTO</option>
						</select>
					</div>						
				  </td>
				</tr>
				<tr>
				  <td>Importe</td>
				  <td><input type='number' name='importe' required="true" min= '1' v-model='movimientos.importe' class="input is-rounded" ></td>
				</tr>
				<tr>
				  <td>Forma De Pago</td>
				  <td>
					<div class="select is-rounded">
						<select name='formaDePago' required="true" v-model='movimientos.formaDePago' >
						  <option value="TRANSFERENCIA" >TRANSFERENCIA</option>
						  <option value="DEPOSITO" >DEPOSITO</option>
						  <option value="EFECTIVO" >EFECTIVO</option>
						  <option value="CHEQUE" >CHEQUE</option>
						  <option value="TARJETA CREDITO" >TARJETA CREDITO</option>
						  <option value="TARJETA DEBITO" >TARJETA DEBITO</option>
						</select>
					</div>
                  </td>
				</tr>
				<tr>
				  <td>Referencia</td>
				  <td><input type='text' name='referencia' v-model='movimientos.referencia' class="input is-rounded" ></td>
				</tr>
				<tr>
				  <td>Comentario</td>
				  <td><input type='text' name='comentario' v-model='movimientos.comentario' class="input is-rounded"></td>
				</tr>

				<tr>
				  <td>Fecha del pago</td>
				  <td><input type='date' id='fecha1' required="true" v-model='movimientos.fecha' class="input is-rounded" >{{formateaFecha(movimientos.fecha)}}</td>
				</tr>
				<tr>
				  <td>Usuario captura</td>
				  <td><input type='text' name='quienCapturo' v-model='movimientos.quienCapturo' disabled class="input is-rounded" ></td>
				</tr>
				<tr>
				  <td>Quien pagó</td>
				  <td><input type='text' name='quienPago' required="true" minlength="4" v-model='movimientos.quienPago' class="input is-rounded" ></td>
				</tr>
				<tr>
				  <td>Donde pagó</td>
				  <td><input type='text' name='donde' required="true" minlength="4" v-model='movimientos.donde' class="input is-rounded"></td>
				</tr>
				<tr>
				  <td>Quien recibió
				  </td>
				  <td><input type='text' name='recibio' required="true" minlength="4" v-model='movimientos.recibio' class="input is-rounded"></td>
				</tr>

				<tr>
				  <td><b>Enviar recibo al mail</b>
				  </td>
				  <td><input type='email' name='envioAlMail' v-model='envioMail' class="input is-rounded" ></td>
				</tr>
			  </tbody>
			</table>

			<div class="container">
				<strong>
				    SUBIR RECIBOS DE IMAGENES O PDF 
	    		</strong>
	    		<div class="large-12 medium-12 small-12 cell">
	      			<label>
	        		    <input type="file" id="miArchivoRentus" ref="cualFile" v-on:change="archivoAsubir()"/>
	      			</label>
	        		<button v-on:click="enviaElArchivo()">Subir</button>
	    		</div>                
	    		<br>
	    		<br>
	  		</div>

			<input type="submit" name="agregandoMovimiento" class="button is-rounded is-primary" >
			<br>
			<br>
		</form>

	</div>

</template>


<script>
	import axios from 'axios';
	import contrat1  from './Contratos-buscar.vue' 

	export default{
			name:'Pago',
			components: {
				hijo1: contrat1
			},
			mounted(){
				this.autorizar();
			},
  			props: ['vector', 'elusuario'],  
			data(){
				return {
					movimientos:{
						tipo:'',
						contrato:'',
						inquilinoNombre:'',
						propiedadNombre:'',
						inquilinoNum:'',
						propiedadNum:'',
						concepto:'A CUENTA RENTA',
						importe:'',
						formaDePago:'TRANSFERENCIA',
						fechaCaptura:'',
						fecha: '',
						quienCapturo:'',
						quienPago:'',
						donde:'',
						refDeposito:'',
						referencia:'',
						comentario:'',
						recibo:'',
						recibio:'',
						giro:'',
						familia:'',
						subfamilia:'',
						dueno:''

					},
					envioMail:'',
					renta: 0,
					idCon:'',
					buscar: false,
					buscar1: false,
					elArchivo:'',
				};
			},
			methods:{
			    formateaNumero(valor1) {
			        return (Number(valor1)).toLocaleString('en-US', {minimumFractionDigits: 2, useGrouping:true});
			    },


			    archivoAsubir(){
			    	// obtiene el archivo seleccionado en el input llamado cualFile en ref parametro
    				this.elArchivo = this.$refs.cualFile.files[0];

    				// obtiene solo el nombre del archivo
    				//console.log(this.elArchivo.name);

 				},

			    enviaElArchivo(){
		                
			            let formData = new FormData();

			            // Se debe llamar igual el id del input y asi tambien 
			            // al recibirlo en subeArchivos.php el primero en el arreglo
			            // de $_FILES se debe llamar tambien igual y en el
			            // move_uploaded_file del .php, en este 
			            // caso miArchivoRentus en los 4 lugares

			            formData.append('miArchivoRentus', this.elArchivo);

				        //Make the request to the POST /single-file URL				        
			            axios.post( 'https://www.directodo.com/Rentus/accesosdb/subeArchivos.php',
			                formData,
			                {
			                	headers: {
			                    	'Content-Type': 'multipart/form-data'     				
			                	}
					        }
					        ).then(function(){
					          	console.log('SUBIDO!!');
					        })
					        .catch(function(){
					          console.log('FALLO!!');
					        });
			        
			    },
				
			  	autorizar(){
			 		// checa si tiene autorizacion
			  		if(!this.vector.includes('MASTERGGUV')){
				  		if(!this.vector.includes('Cobros Altas')){
				  			alert('Seccion no autorizada');
							document.getElementById('altaCobro').hidden = true;
				  			return;
				  		}		  	
				  	}

           			this.movimientos.fecha = this.hoy();

					// llena campos si vienen parametros en la llamada de contratos
					this.movimientos.contrato=this.$route.params.id;

					this.movimientos.inquilinoNum=this.$route.params.inum;				
					this.movimientos.propiedadNum=this.$route.params.pnum;				
					this.movimientos.inquilinoNombre=this.$route.params.ino;				
					this.movimientos.propiedadNombre=this.$route.params.pno;				
					this.movimientos.giro=this.$route.params.gir;				
					this.movimientos.familia=this.$route.params.fam;				
					this.movimientos.subfamilia=this.$route.params.subf;				
					this.movimientos.dueno = this.$route.params.dueno;

					this.envioMail = this.$route.params.mail;
					this.renta = this.$route.params.rentaMes;
					this.movimientos.importe = this.$route.params.rentaMes;

					// el usuario lo toma de los props que se mandan desde otros con v-bind
					this.movimientos.quienCapturo = this.elusuario;

			  	},
			  	hoy(){
			  		// regresa la fecha actual
			  		var fech = new Date();
           			var dia = fech.getDate();
           			if(dia < 10) dia = '0' + dia;
           			var mes = fech.getMonth() + 1;
           			if(mes < 10) mes = '0' + mes;
           			var año = fech.getFullYear();
           			return año + '-' + mes + '-' + dia;
			  	},
				aBuscar(){
					this.buscar=true;
					document.getElementById('visible').style.height = "0";	
					document.getElementById('visible').style.visibility = "hidden";

				},
				recibeC: function(id, inum, pnum, ino, pno, gir, fam, subf, dueno, elmail, renta){
					this.movimientos.contrato=id;
					this.movimientos.inquilinoNombre=ino;
					this.movimientos.propiedadNombre=pno;
					this.movimientos.inquilinoNum=inum;
					this.movimientos.propiedadNum=pnum;
					this.movimientos.giro=gir;
					this.movimientos.familia=fam;
					this.movimientos.subfamilia=subf;
					this.movimientos.dueno=dueno;
					this.movimientos.importe = renta;
					
					this.envioMail = elmail;
					this.renta = renta; 

					this.buscar=false;
					document.getElementById('visible').style.visibility = "visible";			


				},

				folio(){
				    var d = new Date();
					d.setMinutes(d.getMinutes() + d.getTimezoneOffset());
				    var a = d.getYear();
				    var m = d.getMonth();
				    var dia = d.getDate();
				    var h = d.getHours();
				    var m = d.getMinutes();
				    var s = d.getSeconds();
				    return a + m + dia + h + m + s;

				},

				formateaFecha: function (fecha) {
					var d = new Date(fecha); 
					if (Date.parse(d)){
						// pone los minutos de la zona horaria local. Si no lo haces le agrega un dia a la fecha
						d.setMinutes(d.getMinutes() + d.getTimezoneOffset());
						d.setHours(0);
						var opciones = { year: 'numeric', month: 'short', day: 'numeric' };
						d = new Intl.DateTimeFormat('es-mx', opciones).format(d);
						return d

					}else{
						return "sin fecha";
					}
				},

				fechaActual(){      
				    var currentDate = new Date() //hoy
				    var day = currentDate.getDate();
				    var month = currentDate.getMonth() + 1;
				    var year = currentDate.getFullYear();
				    var my_date = year+"-"+month+"-"+day;
				    return my_date;  

				},

				guardarMovimiento(){
					// valida
					if (this.movimientos.contrato == '') {
						alert('falta el contrato');
						return;
					}

					if (confirm(
						"\n\n           Es correcta la informacion ?\n\n" +
						"Inquilino: " + this.movimientos.inquilinoNombre + 
						"\nPropiedad: " + this.movimientos.propiedadNombre + 
						"\nGiro: " + this.movimientos.giro + 
						"\nFamilia: " + this.movimientos.familia + 
						"\nSub familia: " + this.movimientos.subfamilia + 
						"\nDueno: " + this.movimientos.dueno + 
						"\nConcepto: " + this.movimientos.concepto + 
						"\nImporte: $ " + this.formateaNumero(this.movimientos.importe) + 
						"\nForma de pago: " + this.movimientos.formaDePago + 
						"\nReferencia: " + this.movimientos.referencia + 
						"\nComentario: " + this.movimientos.comentario + 
						"\nFecha de pago: " + this.formateaFecha(this.movimientos.fecha) + 
						"\nQuien capturó: " + this.movimientos.quienCapturo + 
						"\nQuien pagó: " + this.movimientos.quienPago + 
						"\nDonde pagó: " + this.movimientos.donde + 
						"\nQuien recibió: " + this.movimientos.recibio + 
						"\nEnviar al mail: " + this.envioMail +
						"\n\n           Es correcta la informacion ?")) {


					} else {
    					return;
					}

					var mov= this.movimientos;
					var router= this.$router;

					// genera folio del recibo					
					this.movimientos.recibo = this.movimientos.inquilinoNum + this.movimientos.propiedadNum + this.movimientos.contrato + this.folio();

					this.movimientos.fechaCaptura = this.fechaActual();

					// lo guardamos como negativo porque es un pago del inquilino
					this.movimientos.importe = - parseFloat(this.movimientos.importe);

					var nombreArchivo = '';
					if (this.elArchivo.name){
						nombreArchivo = this.elArchivo.name;
					} else nombreArchivo = "";

					// se va a insertar el movimiento y a enviar los mails del recibo en imagen
					axios.post('https://www.directodo.com/Rentus/accesosdb/agregaMovimiento.php?tipo=PAGO&contrato='+ this.movimientos.contrato
                        +'&inquilinoNombre='+ this.movimientos.inquilinoNombre
                        +'&propiedadNombre='+ this.movimientos.propiedadNombre
                        +'&inquilinoNum='+ this.movimientos.inquilinoNum
                        +'&propiedadNum='+ this.movimientos.propiedadNum
                        +'&concepto='+ this.movimientos.concepto
                        +'&importe='+ this.movimientos.importe
                        +'&formaDePago='+ this.movimientos.formaDePago
                        +'&fechaCaptura='+ this.movimientos.fechaCaptura
                        +'&fecha='+ this.movimientos.fecha
                        +'&quienCapturo='+ this.movimientos.quienCapturo
                        +'&quienPago='+ this.movimientos.quienPago
                        +'&donde='+ this.movimientos.donde
                        +'&referencia='+ this.movimientos.referencia
                        +'&comentario='+ this.movimientos.comentario
                        +'&recibo='+ this.movimientos.recibo
                        +'&familia='+ this.movimientos.familia
                        +'&subFamilia='+ this.movimientos.subfamilia
                        +'&dueno='+ this.movimientos.dueno
                        +'&giro='+ this.movimientos.giro
                        +'&recibio='+ this.movimientos.recibio
                        +'&envioMail='+ this.envioMail
                        +'&direccionFoto='+ nombreArchivo )
			  		          .then((respue) => {
			  		          		if (respue.statusText == 'OK'){
			  		          			alert("Pago agregado");
			  		          			router.push('/con')
			  		          		}
			  			 	  })
			  		          .catch((error) =>{
			  		          		alert("No se agregó el pago por problema en la base de datos");
			  		          		console.log(error);
			  		          });

				}
			}
	}

</script>

<style>
</style>


// WEBPACK FOOTER //
// src/Pagos.vue